export const api_version = process.env.REACT_APP_VERSION

export const BRAZE_API_KEY = process.env.REACT_APP_BRAZE_API_KEY

export const __striprKey = process.env.REACT_APP_STRIPE_API_KEY

export const AMPLITUDE_KEY = process.env.REACT_APP_AMPLITUDE_KEY

export const REACT_APP_GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY

// Manual kill switch for the native MCA signup/login/about-you flow
// (docs/fiton-care-web-native-signup-login-plan.md). Flip to `false` to fall
// back to the old redirect-to-fiton-web behavior (Welcome.js's
// redirectToMedicareSignup) without a deploy-time feature-flag system —
// just a constant to toggle by hand and redeploy/rollback.
export const USE_NATIVE_MCA_SIGNUP = true
